















































































































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/camelcase */
import { Component, Prop, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';
import Button from '@/components/Button.vue';

@Component({
  components: {
    LayoutContent,
    FormInput,
    Button,
  },
})

export default class Credential extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) data!: any;

  loginID = '';
  userID = '';
  email = '';
  password = '';
  pin = '';
  phoneNumber = '';
  username = '';
  shopeePayPin = '';
  otp = '';
  noHp = '';

  useLoginId = [
    '1022',
    '1061',
    '1061',
    '1041',
  ];

  useUserId = [
    '1081',
  ];

  usePassword = [
    '1022',
    '1061',
    '1081',
    '1041',
    '1085',
  ];

  useEmail = [
    '1022',
  ];

  usePin = [
    '1073',
    '1080',
    '1084',
  ];

  useShopeePayPin = [
    '1085',
  ];

  useOTP = [
    '1084',
    '1085',
  ];

  usePhoneNumber = [
    '1073',
    '1080',
  ];

  useUserName = [
    '1085',
  ];

  useNomorHP = [
    '1084',
  ];

  mounted() {
    this.loadCredential();
  }

  loadCredential() {
    let loginId = '';
    let password = '';
    let email = '';
    let phoneNumber = '';
    let pin = '';
    let userId = '';
    let otp = '';
    let username = '';
    let shopeepayPin = '';
    let noHp = '';

    const { data } = this;

    switch (data.service_code) {
      case '1022':
        loginId = data.detailMerchant.login_id;
        password = `PASS${data.detailMerchant.channel_id}`;
        email = data.detailMerchant.email;
        break;

      case '1061':
        loginId = data.detailMerchant.loginid;
        password = '123456';
        break;

      case '1081':
        userId = data.detailMerchant.user_id;
        password = '1234';
        break;

      case '1073':
        phoneNumber = data.detailMerchant.no_hp;
        pin = data.detailMerchant.pin;
        break;

      case '1041':
        loginId = data.detailMerchant.user_id;
        password = data.detailMerchant.password;
        break;

      case '1080':
        phoneNumber = '081282325566';
        pin = '000000';
        break;

      case '1084':
        noHp = '082114017471';
        pin = '574514';
        otp = '8888';
        break;

      case '1085':
        username = 'bayarindtest';
        password = 'Bayarind123';
        otp = '123456';
        shopeepayPin = '789789';
        break;

      default:
        loginId = '';
    }

    this.password = password;
    this.userID = userId;
    this.username = username;
    this.loginID = loginId;
    this.otp = otp;
    this.noHp = noHp;
    this.phoneNumber = phoneNumber;
    this.pin = pin;
    this.shopeePayPin = shopeepayPin;
    this.email = email;
  }
}
